import { Injectable } from '@angular/core';

/**
 * StorageService — centraliza persistência client-side via localStorage.
 *
 * Segurança:
 * - Nunca armazena tokens isolados — sempre dentro do objeto de sessão
 * - Facilita troca de estratégia futura (cookie, sessionStorage, etc.)
 */
@Injectable({ providedIn: 'root' })
export class StorageService {
  get<T>(key: string): T | null {
    const raw = localStorage.getItem(key);
    if (!raw) return null;

    try {
      return JSON.parse(raw) as T;
    } catch {
      return raw as unknown as T;
    }
  }

  set(key: string, value: unknown): void {
    const serialized = typeof value === 'string' ? value : JSON.stringify(value);
    localStorage.setItem(key, serialized);
  }

  remove(key: string): void {
    localStorage.removeItem(key);
  }

  has(key: string): boolean {
    return localStorage.getItem(key) !== null;
  }

  clearAll(): void {
    localStorage.clear();
  }
}
